'use client';

import { useState, useEffect } from 'react';
import CustomTable from '../../components/CustomTable';
import ModalTipoJanela from './ModalTipoJanela';
import ModalRetorno from '../../components/ModalRetorno';

interface TableProps {
  headers: any;
  onDelete: (selectedData: any[]) => void;
  dados: any[];
  valoPesquisa: string;
}

export default function TabelaTipoJanela({ headers, onDelete, dados, valoPesquisa }: TableProps) {
  const [tableData, setTableData] = useState(dados);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalRetornoOpen, setModalRetornoOpen] = useState(false);
  const [mensagemRetorno, setMensagemRetorno] = useState('');
  const [tipoRetorno, setTipoRetorno] = useState<'sucesso' | 'erro'>('sucesso');

  useEffect(() => {
    setTableData(dados);
  }, [dados]);

  const handleAddTipoJanela = (data: any) => {
    if (data.TipoJanela.trim() !== '') {
      setTableData(prevData => [
        ...prevData,
        {
          id: prevData.length + 1,
          tipojanela: data.TipoJanela,
          descricao: data.descricao,
          observacao: data.observacao,
          ativo: true,
        },
      ]);
      setIsModalOpen(false);
      setMensagemRetorno('Tipo de janela adicionada com sucesso!');
      setTipoRetorno('sucesso');
      setModalRetornoOpen(true);
    }
  };

  const handleDelete = (selectedData: any[]) => {
    const selectedIds = selectedData.map(item => item.id);
    const newData = tableData.filter(item => !selectedIds.includes(item.id));
    setTableData(newData);
    onDelete(selectedData);
    setMensagemRetorno('Itens excluídos com sucesso!');
    setTipoRetorno('sucesso');
    setModalRetornoOpen(true);
  };

  const handleDataChange = (newData: any[]) => {
    setTableData(newData);
  };

  return (
    <>
      <CustomTable
        headers={headers}
        data={tableData}
        searchValue={valoPesquisa}
        onDelete={handleDelete}
        onAdd={() => setIsModalOpen(true)}
        onDataChange={handleDataChange}
        addButtonLabel="Adicionar"
        deleteButtonLabel="Excluir"
        showActions={true}
      />

      <ModalTipoJanela
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        handleAddTipoJanela={handleAddTipoJanela}
      />

      <ModalRetorno
        isOpen={modalRetornoOpen}
        onClose={() => setModalRetornoOpen(false)}
        mensagem={mensagemRetorno}
        tipo={tipoRetorno}
      />
    </>
  );
}
